export const messageBubbleStyleType = {
    SINGLE: 'single',
    TOP: 'top',
    MIDDLE: 'middle',
    BOTTOM: 'bottom',
};